module.exports = __webpack_public_path__ + "media/images/mailer/attachment-24-046df79262a620fa1a7ec2fd42a2a4ab.png";